import { createContext } from 'react';

const Context = createContext({
  user: null,
  loading: false,
  error: null
});

export default Context;
